import React from "react";
import "./styles/footer.sass";

const Footer = () => {
  return (
    <footer>
      <p>&copy;Boro cars - Mateusz Borolewski </p>
      <span>
        <p>Code by:</p>
        <a href='https://github.com/szymonqqq'>Szymon &</a>
        <a href='https://github.com/pawel4985'>Paweł</a>
      </span>
    </footer>
  );
};
export default Footer;
